<template>
  <div>
    <div class="container">
      <div class="kc__title-container">
        <div class="kc__title-left">
          <div class="kc__tabs function-tabs">
            <div
              v-tooltip.bottom-start="{content: 'Filter', ...tooltipOptions}"
              class="kc__tab"
              :class="[{kc__tab__enabled: tableFilters.length}]"
              @click="showFilters = !showFilters"
            >
              <base-material-design-icon
                icon="filter"
                class="kc__icon"
              />
            </div>
            <div
              id="add-tab-dropdown-container"
              v-tooltip.bottom-start="{content: 'Modifications', ...tooltipOptions}"
              class="kc__tab"
              @click="$refs.select.open()"
            >
              <base-select
                id="add-tab-dropdown"
                ref="select"
                :is-hide-arrow="true"
                :options="dataModalOptions"
                align-left
                :title-style="{'padding-left': '5px', 'font-size': '12px', 'font-weight': '900'}"
                :header-style="{height: '20px !important'}"
                :prop-list-style="{cursor: 'pointer'}"
                show-top-border
                :max-height-list="500"
                :placeholder-icon="'plusCircle'"
                :border-less="true"
                :placeholder-style="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
                @change="openDataModal($event)"
              />
            </div>
            <div
              v-tooltip.bottom-start="{content: 'Select All Rows', ...tooltipOptions}"
              class="kc__tab"
              @click="selectAllRows"
            >
              <base-material-design-icon
                icon="check"
                class="kc__icon"
              />
            </div>
            <div
              v-tooltip.bottom-start="{content: 'Bulk Update', ...tooltipOptions}"
              class="kc__tab"
              @click="openBulkUpdateModal()"
            >
              <base-material-design-icon
                icon="flash"
                class="kc__icon"
              />
            </div>
          </div>
          <div class="kc__filter_pills">
            <FilterChips
              :filters="tableFilters"
              :field-labels="fieldLabels"
              @delete="removeFilter($event)"
              @deleteAll="clearFilter(true)"
            />
          </div>
        </div>
        <div class="kc__title-right">
          <div class="kc__tabs page-tabs">
            <div
              v-tooltip.bottom-start="{content: 'Column Editor', ...tooltipOptions}"
              class="kc__tab"
              @click="$modal.show('column-editor')"
            >
              <base-material-design-icon
                icon="tableColumnPlusAfter"
                class="kc__icon"
              />
            </div>
            <div
              v-tooltip.bottom-start="{content: 'Saved Views', ...tooltipOptions}"
              class="kc__tab"
              :class="[{kc__tab__enabled: savedViewSelected}]"
              @click="openCreateTableViewModal"
            >
              <base-material-design-icon
                icon="copy"
                class="kc__icon"
              />
            </div>
            <div
              id="export-tab-dropdown-container"
              v-tooltip.bottom-start="{content: 'Export', ...tooltipOptions}"
              class="kc__tab"
              @click="$refs.export.open()"
            >
              <base-select
                id="export-tab-dropdown"
                ref="export"
                :is-hide-arrow="true"
                :options="exportOptions"
                align-left
                :title-style="{'padding-left': '5px', 'font-size': '12px', 'font-weight': '900'}"
                :header-style="{height: '20px !important'}"
                :prop-list-style="{cursor: 'pointer'}"
                show-top-border
                :max-height-list="500"
                :placeholder-icon="'download'"
                :border-less="true"
                :placeholder-style="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
                @change="exportData($event)"
              />
            </div>
          </div>
          <base-select
            v-model="pageSize"
            :options="paginationOptions"
            align-left
            :title-style="{'padding-left': '5px'}"
            :header-style="{backgroundColor: '#ffffff'}"
            show-top-border
            shift-label-right
            :select-style="{'margin': '5px', 'height': '34px !important', width: '100px !important'}"
            :prop-list-style="{cursor: 'pointer'}"
          />
        </div>
      </div>
      <div
        v-show="showFilters"
        class="kc__filters"
      >
        <div class="kc__filters_header">
          <span class="kc__filters_title">Advanced Filtering</span>
          <base-material-design-icon
            icon="close"
            class="kc__icon kc__filters_close"
            @click="showFilters = false"
          />
        </div>
        <base-census-filter-table
          :columns="getRefreshedColumns()"
          :all-filters="tableFilters"
          :order="filterFieldOrder"
          :get-filter-fields="getFilterFields"
          :field-labels="fieldLabels"
          :is-visible="showFilters"
          @setFilter="setFilter($event, true)"
          @clearFilter="clearFilter(true)"
          @removeFilter="removeFilter($event)"
          @close="showFilters = false"
        />
      </div>
      <div class="metrics">
        <div>
          <span class="metrics__metric">Keywords</span>
          <span class="metrics__metric__filtered">{{ filteredKeywords.toLocaleString('en') }}</span>
          <span
            v-if="filteredKeywords < allKeywords"
            class="metrics__metric"
          >{{ allKeywords.toLocaleString('en')
          }}</span>
          <span
            v-else
            class="metrics__metric"
          />
        </div>
        <div>
          <BaseProgressRing
            :current="filteredKeywords"
            :total="allKeywords"
            class="progress-ring"
          />
        </div>
      </div>
      <div
        v-for="(msv, i) in allMsv"
        v-show="allMsv.length"
        :key="i"
        class="metrics"
      >
        <div>
          <span class="metrics__metric">{{ `${msv.title.toUpperCase()} MSV` }}</span>
          <span
            v-tooltip.top-start="{content: filteredMsv[msv.field].toLocaleString(), ...tooltipOptions}"
            class="metrics__metric__filtered"
          >

            {{ abbreviateNumber(filteredMsv[msv.field]) }}
          </span>
          <span
            v-if="filteredMsv[msv.field] < msv.score"
            class="metrics__metric"
          >{{ msv.score.toLocaleString('en')
          }}</span>
          <span
            v-else
            class="metrics__metric"
          />
        </div>
        <div>
          <BaseProgressRing
            :current="filteredMsv[msv.field]"
            :total="msv.score"
            class="progress-ring"
          />
        </div>
      </div>
      <div class="metrics">
        <div>
          <span class="metrics__metric">Mapped URLs</span>
          <span class="metrics__metric__filtered">{{ filteredMappedUrls.toLocaleString('en') }}</span>
          <span
            v-if="filteredMappedUrls < allMappedUrls"
            class="metrics__metric"
          >{{ allMappedUrls.toLocaleString('en')
          }}</span>
          <span
            v-else
            class="metrics__metric"
          />
        </div>
        <div>
          <BaseProgressRing
            :current="filteredMappedUrls"
            :total="allMappedUrls"
            class="progress-ring"
          />
        </div>
      </div>
      <div class="metrics">
        <div>
          <span class="metrics__metric">Ranked URLs</span>
          <span class="metrics__metric__filtered">{{ filteredRankingUrls.toLocaleString('en') }}</span>
          <span
            v-if="filteredRankingUrls < allRankingUrls"
            class="metrics__metric"
          >{{
            allRankingUrls.toLocaleString('en') }}</span>
          <span
            v-else
            class="metrics__metric"
          />
        </div>
        <div>
          <BaseProgressRing
            :current="filteredRankingUrls"
            :total="allRankingUrls"
            class="progress-ring"
          />
        </div>
      </div>
      <div
        id="main-table"
        ref="table"
        onContextMenu="return(false)"
      />
    </div>
    <modal
      name="column-editor"
      v-bind="modalProps"
    >
      <ColumnEditor
        ref="column-editor"
        :columns="getRefreshedColumns()"
        @toggle="toggleColumnVisibility"
        @close="$modal.hide('column-editor')"
      />
    </modal>
    <modal
      name="bulk-update"
      v-bind="modalProps"
    >
      <BulkUpdate
        ref="bulk-update"
        :msv-labels="allMsv"
        :url-opts="mappedUrls"
        :selected-ids="selectedIds"
        :show-difficulty-score="showDifficultyScore"
        :filtered-keywords="filteredKeywords"
        @close="$modal.hide('bulk-update')"
        @apply="applyBulkUpdate($event)"
      />
    </modal>
    <modal
      name="add-keywords"
      v-bind="modalProps"
    >
      <CreateKeywords
        ref="add-keywords"
        :web-property-patterns="webPropertyPatterns"
        :mapped-urls="mappedUrls.slice(1)"
        :msv-label-list="allMsv"
        :show-difficulty-score="showDifficultyScore"
        @close="$modal.hide('add-keywords')"
        @applyKeywords="applyKeywords($event)"
      />
    </modal>
    <modal
      name="add-urls"
      v-bind="modalProps"
    >
      <CreateUrls
        ref="add-urls"
        :mapped-urls="mappedUrls.slice(1)"
        :web-property-patterns="webPropertyPatterns"
        @close="$modal.hide('add-urls')"
        @applyUrls="applyUrls($event)"
      />
    </modal>
    <modal
      name="history"
      v-bind="modalProps"
    >
      <base-keyword-history-modal
        :keyword="selectedKeyword"
        @close="closeHistoryModal"
      />
    </modal>
    <modal
      name="create-table-view"
      v-bind="modalProps"
    >
      <CreateTableView
        ref="create-table-view"
        :views.sync="savedViews"
        :client-id="selectedClient && selectedClient._id"
        :user-id="currentUser && currentUser._id"
        :current-table-view-hash.sync="currentTableViewHash"
        @close="$modal.hide('create-table-view')"
        @select="setTableView($event)"
        @apply="applySaveTableView($event)"
        @delete="handleDeleteTableView($event)"
      />
    </modal>
    <modal
      name="create-section"
      v-bind="modalProps"
    >
      <CreateSection
        ref="create-section"
        :data="sectionData"
        @apply="applySection($event)"
        @cancel="$modal.hide('create-section')"
      />
    </modal>
    <modal
      name="create-keyword-attribute"
      v-bind="modalProps"
    >
      <CreateKeywordAttribute
        ref="create-keyword-attribute"
        @apply="applyKeywordAttribute($event)"
        @cancel="$modal.hide('create-keyword-attribute')"
      />
    </modal>
    <modal
      name="create-url-attribute"
      v-bind="modalProps"
    >
      <CreateUrlAttribute
        ref="create-url-attribute"
        :select-options="createUrlSelectOptions"
        @close="$modal.hide('create-url-attribute')"
      />
    </modal>
    <modal
      name="edit-url"
      v-bind="modalProps"
    >
      <UrlEdit
        ref="edit-url"
        url-id="create-new-url"
        @edit="table.setData()"
        @close="$modal.hide('edit-url')"
      />
    </modal>
    <modal name="new-keywords-modal" v-bind="modalProps" >
      <new-keyword-discovery-modal 
        @close="$modal.hide('new-keywords-modal')"
        @keywords-changed="handleKeywordsChange()"
        :mapped-urls="mappedUrls.slice(1)"
      />
     </modal>
    <div
      v-if="isDataUpdating"
      class="kc__update-loader"
    >
      <base-loader class="kc__update-loader-ring" />
    </div>
    <base-material-design-icon
      ref="iconQuestion"
      style="font-size:14px;vertical-align:top;"
      icon="questionCircle"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import baseModalProps from '@/common/BaseModalProps'

import Tabulator from 'tabulator-tables'
import ToasterService from '@/services/toasterService'
import tableColumns from './tableColumns'
import fieldLabels from './fieldLabels'
import ColumnEditor from './ColumnEditor'
import BulkUpdate from './BulkUpdate'
import CreateKeywords from './CreateKeywords'
import CreateUrls from './CreateUrls'
import CreateSection from '../sections/CreateUpdateSectionPopup'
import CreateKeywordAttribute from '../keyword-attributes/CreateUpdateKeywordAttributePopup'
import CreateUrlAttribute from '../url-attributes/AddNew'
import FilterChips from './FilterChips'
import CreateTableView from './CreateTableView'
import { cloneDeep, debounce, isEqual } from 'lodash'
import moment from 'moment'
import UrlEdit from '../url-census/Edit'
import NewKeywordDiscoveryModal from './NewKeywordDiscoveryModal'
import { EventBus } from '@/services/eventBus'

const order = {
  'attribute': 1, // 1   Attirbute   this was not included in original list
  'url': 2, // 2   Mapped URL
  'keyword': 3, // 3   Keyword
  'url_status': 4, // 4   URL Status
  'score': 5, // 5   Score
  'metric_msv_broad_adjusted_1': 6, // 6   MSV 1
  'metric_msv_broad_adjusted_2': 7, // 7   MSV 2
  'metric_msv_broad_adjusted_3': 8, // 7   MSV 2
  'metric_msv_broad_adjusted_4': 9, // 7   MSV 2
  'rank_zone': 10, // 8   Rank Zone
  // 'rank_current_url': 9, // 9   Ranking
  'section': 11, // 10  Section
  'rank_current_url': 12, // 11  Ranking URL
  'rank_zone_baseline': 13, // 15  Baseline Rank Zone
  'url_match': 14, // 16  Baseline Rank Zone
  'content_brief_status': 15,
  'writing_status': 16,
  'url_optimized': 17,
  // 'url_attribute': 21
  'metric_rank_current': 18,
  'rank_blur_count': 19,
  'published_url': 20,
  'product_grids': 21,
  'total_product_cards': 22,
  'seller_cards': 23
}

Tabulator.prototype.extendModule('filter', 'filters', {
  'Containing': function () { return true },
  'Word matching': function () { return true },
  'Exactly matching': function () { return true },
  'Begins with': function () { return true },
  'Ends with': function () { return true }
})

const SELECT_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]

let ajaxUrl = '/rest/keyword-census/table'
if (process.env.VUE_APP_IS_V2_API === 'true') {
  ajaxUrl = '/rest/v2/keyword-census/table'
}

export default {
  name: 'KeywordCensus',
  components: { ColumnEditor, NewKeywordDiscoveryModal, BulkUpdate, CreateKeywords, CreateUrls, FilterChips, CreateTableView, CreateSection, CreateKeywordAttribute, CreateUrlAttribute, UrlEdit },
  props: {
    filterUrl: {
      type: String,
      default: ''
    },
    urlClientId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      table: null,
      tableData: [],
      fieldLabels: fieldLabels,
      filterFieldOrder: cloneDeep(order),
      isQueryFiltersApplied: false,
      isDataLoading: false,
      currentTableViewHash: null,
      savedViews: {},
      exportOptions: [
        {
          label: 'Analyst Export (XLS)',
          value: `/keyword_census/export?report_type=analyst&_cache=${Math.floor(Math.random() * 9999999) + 1}`
        },
        {
          label: 'Bulk Update Export (CSV)',
          value: `/keyword_census/export?report_type=bulk_update&_cache=${Math.floor(Math.random() * 9999999) + 1}`
        },
        {
          label: 'Product Grid Export (CSV)',
          value: `/keyword_census/export?report_type=product&_cache=${Math.floor(Math.random() * 9999999) + 1}`
        },
        {
          label: 'Data View Export (CSV)',
          value: '#download-csv'
        },
        {
          label: 'Data View Copy to Clipboard',
          value: '#copy-csv'
        }
      ],
      dataModalOptions: [
        {
          label: 'Add Your Keywords',
          value: 1
        },
        {
          label: 'Find New Keywords',
          value: 7
        },
        {
          label: 'Add URLs',
          value: 2
        },
        {
          label: 'Create URL',
          value: 3
        },
        {
          label: 'Create Section',
          value: 4
        },
        {
          label: 'Create Keyword Attribute',
          value: 5
        },
        {
          label: 'Create URL Attribute',
          value: 6
        }
      ],
      paginationOptions: [
        {
          label: '100',
          value: 100
        },
        {
          label: '250',
          value: 250
        },
        {
          label: '500',
          value: 500
        },
        {
          label: '1000',
          value: 1000
        }
      ],
      filteredKeywords: 0,
      allKeywords: 0,
      filteredMappedUrls: 0,
      allMappedUrls: 0,
      filteredRankingUrls: 0,
      allRankingUrls: 0,
      filteredProductData: {
        total_product_cards: 0,
        product_grids: 0,
        seller_cards: 0
      },
      filteredMsv: {
        metric_msv_broad_adjusted_1: 0,
        metric_msv_broad_adjusted_2: 0,
        metric_msv_broad_adjusted_3: 0,
        metric_msv_broad_adjusted_4: 0
      },
      msvLabels: {},
      contentBriefParams: {},
      urlParams: {},
      mappedUrls: [],
      urlStatuses: [],
      relScores: [],
      sections: [],
      contentBriefStatuses: [],
      writingStatuses: [],
      pageTypes: [],
      allMsv: [],
      isDataUpdating: false,
      showFilters: false,
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip-arrow'
      },
      opts: {
        urls: [
          {
            value: -1,
            label: 'Not Set'
          },
          {
            value: 0,
            label: 'Remove Record'
          }
        ],
        sources: [
          {
            value: -1,
            label: 'Not Set'
          }
        ]
      },
      selectedKeyword: '',
      webPropertyPatterns: [],
      createUrlSelectOptions: SELECT_OPTIONS,
      showDifficultyScore: true
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('keywordCensus', ['tableFilters']),
    ...mapState('projectSettings', {
      sectionData(state) {
        return {
          opts: {
            is_active: [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }],
            target_geo: [{ value: -1, label: '--- Not Set ---' }, ...state.targetGeoOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)],
            target_device: [{ value: -1, label: '--- Not Set ---' }, ...state.targetDeviceOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)],
            target_locale: [{ value: -1, label: '--- Not Set ---' }, ...state.targetLocaleOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)]
          },
          defaultSection: state.projectData
        }
      }
    }),
    modalProps() {
      const modalProps = {
        width: '75%'
      }
      return { ...baseModalProps, ...modalProps }
    },
    pageSize: {
      get: function () {
        return this.table ? this.table.getPageSize() : 100
      },
      set: function (newValue) {
        this.table.setPageSize(newValue)
      }
    },
    savedViewSelected() {
      return Object.keys(this.savedViews).some(category => this.savedViews[category].some(view => view.id === this.currentTableViewHash))
    },
    isUserSuperAdmin() {
      return this.userRoles.includes('admin')
    },
    selectedIds() {
      return this.table ? this.table.getSelectedData().map(row => row.id) : []
    },
    rows() {
      return this.table ? this.table.getRows() : []
    },
    // tableFilters () {
    //   return this.table ? this.table.getFilters(true) : []
    // },
    tableHeaderFilters() {
      return this.table ? this.table.getHeaderFilters() : []
    },
    tableViewData() {
      return {
        filters: this.table ? [...this.table.getFilters(), ...this.table.getHeaderFilters()] : [],
        sorters: this.table ? this.table.getSorters().map(sorter => ({ dir: sorter.dir, column: sorter.field })) : [],
        columns: this.table ? this.table.getColumnLayout() : []
      }
    }
  },
  watch: {
    tableFilters: {
      handler() {
        this.handleTableViewDataChange(this.getUpdatedTableViewData())
      },
      deep: true
    },
    tableData: {
      handler(newData) {
        this.table.replaceData(newData)
      },
      deep: true
    },
    tableViewData: {
      handler(newData) {
        this.handleTableViewDataChange(newData)
      },
      deep: true
    },
    clientId: {
      handler(v) {
        let callback
        if (v && !this.isQueryFiltersApplied) {
          if (this.filterUrl) {
            if (v === this.urlClientId) {
              callback = () => {
                this.table.setFilter([{
                  field: 'url',
                  type: '=',
                  value: this.filterUrl
                }])
              }
              this.isQueryFiltersApplied = true
            } else {
              if (!this.setNewClient(this.urlClientId, true)) {
                this.isQueryFiltersApplied = true
              }
            }
          } else {
            this.isQueryFiltersApplied = true
          }
        }
        if (!this.isDataLoading) {
          this.loadData(callback)
          this.loadAggregates()
          this.getProjectSettings(this.clientId)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.rawIconQuestionHtmlString = this.$refs.iconQuestion.$el.outerHTML.toString()
    this.$refs.iconQuestion.$el.parentNode.removeChild(this.$refs.iconQuestion.$el)
    
    // Check for #add-keywords fragment and show modal if present
    console.log('window.location', window.location)
    const hash = window.location.hash
    const hashParts = hash.split('#')
    if (hashParts.length > 2) {
      const secondHash = hashParts[2]
      console.log('second hash:', secondHash)
      if (secondHash === 'add-keywords') {
        console.log('show modal from second hash')
        this.$nextTick(() => {
          this.$modal.show('add-keywords')
        })
      }
    }
  },
  created () {
    EventBus.$on('keywords-added', this.handleKeywordsDiscovered)
  },
  beforeDestroy() {
    EventBus.$off('keywords-added', this.handleKeywordsDiscovered)
  },
  methods: {
    ...mapActions('keywordCensus', [
      'getSavedViewOpts',
      'patchTableView',
      'getTableView',
      'deleteTableView',
      'postTableView',
      'getOpts',
      'postBulkUpdate',
      'postKeywords',
      'postUrls',
      'updateField',
      'getFilterFields',
      'getSavedViews',
      'getUrlOpts',
      'getAggregates',
      'updateTableFilters']),
    ...mapActions('sections', ['createSection']),
    ...mapActions('projectSettings', ['getProjectSettings']),
    ...mapActions('keywordAttributes', ['createKeywordAttribute']),
    toggleColumnVisibility(field) {
      this.table.toggleColumn(field)
    },
    handleKeywordsDiscovered () {
      const filters = this.table ? [...this.table.getFilters(), ...this.table.getHeaderFilters()] : []
      const callback = () => {
        this.table.setFilter([...filters])
      }
      this.loadData(callback)
    },
    getUpdatedTableViewData() {
      const newFilters = this.table ? [...this.table.getFilters(), ...this.table.getHeaderFilters()] : []
      return {
        filters: newFilters,
        sorters: this.table ? this.table.getSorters().map(sorter => ({ dir: sorter.dir, column: sorter.field })) : [],
        columns: this.table ? this.table.getColumnLayout() : []
      }
    },
    debouncedHandleTableViewDataChange: debounce(async (changes, scope) => {
      const data = await scope.postTableView({ form: changes, clientId: scope.selectedClient._id, type: 'keyword_census' })
      scope.currentTableViewHash = data.data
      scope.$router.replace({ name: scope.$route.name, params: { id: data.data } })
      scope.$route.params.id = null
    }, 500),
    handleTableViewDataChange(changes) {
      this.debouncedHandleTableViewDataChange(changes, this)
    },
    getRefreshedColumns() {
      return this.table ? cloneDeep(this.table.getColumns()) : []
    },
    updateFilters() {
      const advancedFilters = this.table ? this.table.getFilters() : []
      const headerFilters = this.table ? this.table.getHeaderFilters() : []
      this.updateTableFilters({ advancedFilters, headerFilters })
    },
    selectAllRows() {
      this.selectedIds.length ? this.table.deselectRow() : this.table.selectRow()
    },
    setFilter(filters, setFromAdvancedFilterModal = false) {
      // handle 'in' filters set in adv. filter modal
      filters = filters.map(filter => {
        if (filter.type === 'in' && !Array.isArray(filter.value)) {
          filter.value = [filter.value]
        }
        return filter
      })
      filters = filters.filter(filter => {
        filter = {
          field: filter.field,
          type: filter.type,
          value: filter.value
        }
        if (setFromAdvancedFilterModal) {
          return filter
        }
        return this.tableFilters.every(existingFilter => {
          existingFilter = {
            field: existingFilter.field,
            type: existingFilter.type,
            value: existingFilter.value
          }
          return !isEqual(existingFilter, filter)
        })
      })
      if (!setFromAdvancedFilterModal) {
        filters = [...filters, ...this.tableFilters]
      }
      this.table.setFilter(filters)
      this.showFilters = false
    },
    removeFilter(filter) {
      let newValue = null
      const columnExists = this.table.getColumn(filter.field)
      let headerFilterType = 'in'
      if (columnExists) { // handle 'url_attribute'
        headerFilterType = this.table.getColumn(filter.field)._column.definition.headerFilterFunc
      }
      const headerFilterValue = this.table.getHeaderFilterValue(filter.field)
      const headerFilterRemoved = filter.type === headerFilterType && filter.value === headerFilterValue
      if (headerFilterType === 'in') {
        let currentValue = [filter.value]
        if (columnExists) { // handle 'url_attribute'
          currentValue = this.table.getHeaderFilterValue(filter.field).split(/,\s*/)
        }
        newValue = currentValue.filter(value => value !== filter.value)
        newValue = newValue.filter(value => value.trim().length)
        if (!newValue.length) {
          newValue = null
        }
        this.table.setHeaderFilterValue(filter.field, newValue || '')
        let deletedFilter = this.table.getFilters().filter(obj => {
          return obj.field === filter.field && obj.type === filter.type && obj.value.includes(filter.value)
        })
        deletedFilter = deletedFilter.length ? deletedFilter[0] : null
        if (deletedFilter) {
          this.table.removeFilter(filter.field, filter.type, deletedFilter.value)
        }
      } else if (headerFilterRemoved) {
        this.table.setHeaderFilterValue(filter.field, newValue)
      }
      this.table.removeFilter(filter.field, filter.type, filter.value)
    },
    clearFilter(shouldClearHeaders = false) {
      this.table.clearFilter(shouldClearHeaders)
    },
    async openCreateTableViewModal() {
      this.$modal.show('create-table-view')
    },
    setTableView(event) {
      this.$modal.hide('create-table-view')
      this.$router.replace({ name: this.$route.name, params: { id: event } })
      this.loadData()
    },
    exportData(event) {
      switch (event) {
        case '#copy-csv':
          this.table.copyToClipboard('table')
          break
        case '#download-csv': {
          const title = moment().format(`[${this.selectedClient.name}]-YYYYMMDD-HHmmss-[export]`)
          this.table.download('csv', `${title}.csv`)
          break
        }
        default:
          if (process.env.VUE_APP_IS_V2_API === 'true') {
            const idx = event.indexOf('keyword_census')
            event = event.slice(0, idx) + 'rest/v2/' + event.slice(idx)
            event = event.replace('keyword_census', 'keyword-census')
          }
          window.location.href = event
      }
    },
    openBulkUpdateModal() {
      this.loadUrlOpts()
      this.$modal.show('bulk-update')
    },
    openDataModal(event) {
      switch (event) {
        case 1:
          this.$modal.show('add-keywords')
          break
        case 2:
          this.loadUrlOpts()
          this.$modal.show('add-urls')
          break
        case 3:
          this.$modal.show('edit-url')
          break
        case 4:
          this.$modal.show('create-section')
          break
        case 5:
          this.$modal.show('create-keyword-attribute')
          break
        case 6:
          this.$modal.show('create-url-attribute')
          break
        case 7:
          this.$modal.show('new-keywords-modal')
          break
      }
    },
    updatePageSize() {
      this.table.setPageSize(this.pageSize)
    },
    openHistoryModal(keyword) {
      this.selectedKeyword = keyword
      this.$modal.show('history')
    },
    closeHistoryModal(isUrlChanged) {
      this.selectedKeyword = ''
      this.$modal.hide('history')
      if (isUrlChanged) {
        this.table.setData()
      }
    },
    keywordGauge() {
      return this.allKeywords === this.filteredKeywords ? `${this.allKeywords.toLocaleString('en')}` : `${this.filteredKeywords.toLocaleString('en')} / ${this.allKeywords.toLocaleString('en')}`
    },
    msvGauge(msv) {
      return msv.score === this.filteredMsv[msv.field] ? `${msv.score.toLocaleString('en')}` : `${this.filteredMsv[msv.field].toLocaleString('en')} / ${msv.score.toLocaleString('en')}`
    },
    mappedUrlGauge() {
      return this.allMappedUrls === this.filteredMappedUrls ? `${this.allMappedUrls.toLocaleString('en')}` : `${this.filteredMappedUrls.toLocaleString('en')} / ${this.allMappedUrls.toLocaleString('en')}`
    },
    rankingUrlGauge() {
      return this.allRankingUrls === this.filteredRankingUrls ? `${this.allRankingUrls.toLocaleString('en')}` : `${this.filteredRankingUrls.toLocaleString('en')} / ${this.allRankingUrls.toLocaleString('en')}`
    },
    getAllTableFilters() {
      // return this.table
      //   ? this.table.getFilters().concat(this.table.getHeaderFilters())
      //   : []
      return this.table ? this.table.getFilters(true) : []
    },
    loadAggregates() {
      this.getAggregates({ filters: this.getAllTableFilters(), clientId: this.clientId })
        .then(data => {
          this.filteredKeywords = data._filtered_keywords
          this.filteredMappedUrls = data._filtered_mapped_urls
          this.filteredRankingUrls = data._filtered_ranking_urls
          this.filteredMsv = data._filtered_msv
          this.filteredProductData = data._filtered_product_data

          this.allKeywords = data._all_keywords
          this.allMappedUrls = data._all_mapped_urls
          this.allRankingUrls = data._all_ranking_urls
          this.allMsv = data._all_msv

          this.table && this.table.recalc()
        })
    },
    getPercentString(part, total) {
      return (part === total || total === 0) ? '100%' : `${(part / total * 100).toFixed(2)}%`
    },
    abbreviateNumber(num) {
      if (num >= 1000000000000) {
        return (num / 1000000000000).toFixed(1) + 'T'
      }
      if (num >= 1000000000) {
        if ((num / 1000000000).toFixed() === '1000000000') {
          return '1T'
        }
        return (num / 1000000000).toFixed(1) + 'B'
      }
      if (num >= 1000000) {
        if ((num / 1000000).toFixed() === '1000000') {
          return '1B'
        }
        return (num / 1000000).toFixed(1) + 'M'
      }
      if (num >= 1000) {
        if ((num / 1000).toFixed() === '1000') {
          return '1M'
        }
        return (num / 1000).toFixed(1) + 'K'
      }
      return num.toFixed(1)
    },
    updateOrRemoveColumn(columnName, tableColumnsCopy) {
      const idx = tableColumnsCopy.findIndex(col => col.field === columnName)
      if (columnName === 'difficulty_score') {
        if (!this.showDifficultyScore) {
          tableColumnsCopy.splice(idx, 1)
        }
      } else if (columnName.startsWith('metric_msv_broad_adjusted_')) {
        if (this.msvLabels[columnName]) {
          tableColumnsCopy[idx].title = this.msvLabels[columnName]
          fieldLabels[columnName] = this.msvLabels[columnName]
        } else {
          tableColumnsCopy.splice(idx, 1)
          delete this.filterFieldOrder[columnName]
        }
      }
    },
    async loadData(callback) {
      this.isDataUpdating = true
      this.isDataLoading = true
      let selectedClientId = this.selectedClient._id
      let savedViewData = {}
      const savedViewHash = this.$route.params.id
      if (savedViewHash) {
        const savedView = await this.getTableView({ data: savedViewHash, clientId: selectedClientId })
        if (savedView.data.client_id) {
          this.setNewClient(savedView.data.client_id, true)
          selectedClientId = savedView.data.client_id
        }
        if (!savedView.errors.length) {
          savedViewData = savedView.data.data
        }
        this.$route.params.id = null
      }
      let [opts, savedViews] = await Promise.all([
        this.getOpts(selectedClientId),
        this.getSavedViews({ userId: this.currentUser._id, clientId: this.selectedClient._id })
      ])

      this.savedViews = savedViews
      this.isDataUpdating = false
      if (opts) {
        this.msvLabels = opts.msv_labels
        this.showDifficultyScore = opts.show_difficulty_score
        this.urlStatuses = opts.header_filter_params.url_status
        this.relScores = opts.header_filter_params.rel_score
        this.sections = opts.header_filter_params.section
        this.writingStatuses = opts.header_filter_params.writing_status
        this.contentBriefStatuses = opts.header_filter_params.content_brief_status
        this.pageTypes = opts.header_filter_params.page_type
        this.filterFieldOrder = cloneDeep(order)
        this.loadTable(savedViewData)
      }
      callback && callback()
      this.updateFilters()
    },
    async applyBulkUpdate(form) {
      this.sendRequestFromModal('bulk-update', this.postBulkUpdate({ clientId: this.selectedClient._id, form }))
    },
    async applyKeywords(form) {
      this.sendRequestFromModal('add-keywords', this.postKeywords({ clientId: this.selectedClient._id, form }))
    },
    async applyUrls(form) {
      this.sendRequestFromModal('add-urls', this.postUrls({ clientId: this.selectedClient._id, form }))
    },
    async applySection(section) {
      this.sendRequestFromModal('create-section', this.createSection({ clientId: this.selectedClient._id, section }))
    },
    async applyKeywordAttribute(keywordAttribute) {
      this.sendRequestFromModal('create-keyword-attribute', this.createKeywordAttribute({ clientId: this.clientId, keywordAttribute }))
    },
    async applyUrlAttribute(urlAttribute) {
      this.sendRequestFromModal('create-url-attribute', this.createurlAttribute({ clientId: this.clientId, urlAttribute }))
    },
    async loadUrlOpts() {
      const newUrls = await this.getUrlOpts(this.clientId)
      this.mappedUrls.splice(0, this.mappedUrls.length, ...newUrls)
      if (this.mappedUrls[0].value !== -1) {
        this.mappedUrls.unshift({ 'label': 'Remove URL', 'value': '-1' })
      }
    },
    async applySaveTableView({ details, tableViewId, closeModal = true }) {
      const data = await this.patchTableView({ details, tableViewId, clientId: this.selectedClient._id })
      if (data.errors.length) {
        data.errors.forEach(err => {
          ToasterService.showToast(ToasterService.ERROR_TYPE, err)
        })
      } else {
        ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Saved Table View!')
        this.handleTableViewDataChange(this.getUpdatedTableViewData())
        if (closeModal) {
          this.$modal.hide('create-table-view')
        } else {
          this.savedViews = await this.getSavedViews({ userId: this.currentUser._id, clientId: this.selectedClient._id, type: 'keyword_census' })
        }
        if (data.created) {
          this.$modal.hide('create-table-view')
        }
      }
    },
    async handleDeleteTableView({ tableViewId, closeModal = true }) {
      const data = await this.deleteTableView({ tableViewId, clientId: this.selectedClient._id })
      if (data.errors.length) {
        data.errors.forEach(err => {
          ToasterService.showToast(ToasterService.ERROR_TYPE, err)
        })
      } else {
        ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Deleted Table View!')
        this.handleTableViewDataChange(this.getUpdatedTableViewData())
        if (closeModal) {
          this.$modal.hide('create-table-view')
        } else {
          this.savedViews = await this.getSavedViews({ userId: this.currentUser._id, clientId: this.selectedClient._id, type: 'keyword_census' })
        }
      }
    },
    async sendRequestFromModal(modalName, request) {
      if (modalName !== 'add-keywords') {
        this.isDataUpdating = true
      }
      let response = null
      try {
        response = await request
        if (modalName === 'add-keywords') {
          const options = {
            duration: null,
            action: {
              icon: 'times',
              onClick(e, toastObject) {
                toastObject.goAway(0)
              }
            }
          }
          if (response.data.existing_keywords && response.data.existing_keywords.length) {
            const quickAddExistingKeywords = response.data.existing_keywords
            let isPlural = quickAddExistingKeywords.length > 1
            ToasterService.showToast(
              ToasterService.INFO_TYPE,
              `Skipped - ${quickAddExistingKeywords.length} keyword${isPlural ? 's' : ''} already exist${!isPlural ? 's' : ''} - displayed in table`,
              options
            )
            const filters = quickAddExistingKeywords.map(keyword => {
              return {
                field: 'keyword',
                type: 'Exactly matching',
                value: keyword
              }
            })
            this.table.setFilter(filters)
          }
          if (response.data.added_count) {
            let isPlural = response.data.added_count > 1
            ToasterService.showToast(
              ToasterService.SUCCESS_TYPE,
              `Added ${response.data.added_count} Keyword${isPlural ? 's' : ''}`,
              options
            )
          }
        }
        this.table.setData()
        this.$modal.hide(modalName)
      } catch (e) {
        this.$refs[modalName].showErrors(e[0])
      } finally {
        this.isDataUpdating = false
        // Stop loading on the CreateKeywords component if it exists
        if (modalName === 'add-keywords' && this.$refs['add-keywords']) {
          this.$refs['add-keywords'].stopLoading()
        }
      }
    },
    loadTable(savedParams) {
      savedParams = Object.keys(savedParams).length ? savedParams : null
      let tableColumnsCopy = cloneDeep(tableColumns)
      if (savedParams) {
        if (savedParams.columns && savedParams.columns.length) {
          localStorage.removeItem('tabulator-kwc_table-columns')
          // First hide all fields to account for any recently created columns
          tableColumnsCopy.forEach(col => col.visible = false)
          savedParams.columns.forEach(savedCol => {
            const column = tableColumnsCopy.find(col => col.field === savedCol.field)
            Object.assign(column, savedCol)
          })
        }
        if (savedParams.sorters && savedParams.sorters.length) {
          const sortHelper = savedParams.columns.map(obj => obj.field)
          tableColumnsCopy.sort((a, b) => {
            return sortHelper.indexOf(a.field) - sortHelper.indexOf(b.field)
          })
        }
        if (this.table) {
          this.table.setColumnLayout(tableColumnsCopy)
        }
      }

      tableColumnsCopy.forEach(col => {
        if (col.cellDblClick || col.cellClick || col.cellContext) {
          col.titleFormatter = () => {
            return `${col.title}&nbsp;&nbsp;${this.rawIconQuestionHtmlString}`
          }
          col.headerTooltip = () => {
            let definitions = ''
            if (col.cellClick) {
              definitions += col.cellClickDescription + '\n'
            }
            if (col.cellDblClick) {
              definitions += col.cellDblClickDescription + '\n'
            }
            if (col.cellContext) {
              definitions += col.cellContextDescription + '\n'
            }
            return `${col.title}\n\n${definitions}`
          }
        }
      })

      let paramLookup = () => ({ filteredKeywords: this.filteredKeywords })
      tableColumnsCopy.find(col => col.field === 'keyword').topCalcParams = paramLookup

      paramLookup = () => ({ filteredMsv: this.filteredMsv })
      tableColumnsCopy.find(col => col.field === 'metric_msv_broad_adjusted_1').topCalcParams = paramLookup
      tableColumnsCopy.find(col => col.field === 'metric_msv_broad_adjusted_2').topCalcParams = paramLookup
      tableColumnsCopy.find(col => col.field === 'metric_msv_broad_adjusted_3').topCalcParams = paramLookup
      tableColumnsCopy.find(col => col.field === 'metric_msv_broad_adjusted_4').topCalcParams = paramLookup

      paramLookup = () => ({ filteredProductData: this.filteredProductData })
      tableColumnsCopy.find(col => col.field === 'total_product_cards').topCalcParams = paramLookup
      tableColumnsCopy.find(col => col.field === 'product_grids').topCalcParams = paramLookup
      tableColumnsCopy.find(col => col.field === 'seller_cards').topCalcParams = paramLookup

      this.updateOrRemoveColumn('metric_msv_broad_adjusted_1', tableColumnsCopy)
      this.updateOrRemoveColumn('metric_msv_broad_adjusted_2', tableColumnsCopy)
      this.updateOrRemoveColumn('metric_msv_broad_adjusted_3', tableColumnsCopy)
      this.updateOrRemoveColumn('metric_msv_broad_adjusted_4', tableColumnsCopy)

      this.updateOrRemoveColumn('difficulty_score', tableColumnsCopy)

      tableColumnsCopy.find(col => col.field === 'content_brief_status').formatterParams = this.contentBriefParams

      tableColumnsCopy.find(col => col.field === 'metric_rank_current').cellDblClick = (e, cell) => {
        const keyword = cell.getRow().getCell('keyword').getValue()
        vueComponent.openHistoryModal(keyword)
      }
      tableColumnsCopy.find(col => col.field === 'rank_blur_count').cellDblClick = (e, cell) => {
        const keyword = cell.getRow().getCell('keyword').getValue()
        vueComponent.openHistoryModal(keyword)
      }

      const formatRank = (cell) => {
        if (cell.getValue() === 204) {
          return 'NR'
        }
        if (cell.getValue() === 404) {
          return 'ND'
        }
        return cell.getValue()
      }
      const metricRankCurrentColumn = tableColumnsCopy.find(col => col.field === 'metric_rank_current')
      metricRankCurrentColumn.formatter = formatRank
      metricRankCurrentColumn.accessorDownload = (value) => value === 204 ? 'NR' : value === 404 ? 'ND' : value

      const metricRankBaselineColumn = tableColumnsCopy.find(col => col.field === 'metric_rank_baseline')
      metricRankBaselineColumn.formatter = formatRank
      metricRankBaselineColumn.accessorDownload = (value) => value === 204 ? 'NR' : value === 404 ? 'ND' : value

      const urlStatusColumn = tableColumnsCopy.find(col => col.field === 'url_status')
      urlStatusColumn.headerFilterParams.values = this.urlStatuses

      const relScoreColumn = tableColumnsCopy.find(col => col.field === 'score')
      relScoreColumn.headerFilterParams.values = this.relScores

      const contentBriefStatusColumn = tableColumnsCopy.find(col => col.field === 'content_brief_status')
      contentBriefStatusColumn.headerFilterParams.values = this.contentBriefStatuses

      const writingStatusColumn = tableColumnsCopy.find(col => col.field === 'writing_status')
      writingStatusColumn.headerFilterParams.values = this.writingStatuses

      const sectionColumn = tableColumnsCopy.find(col => col.field === 'section')
      sectionColumn.headerFilterParams.values = ['- blank -', ...this.sections]

      const urlPageTypesColumn = tableColumnsCopy.find(col => col.field === 'url_page_type')
      urlPageTypesColumn.headerFilterParams.values = ['- blank -', ...this.pageTypes]

      const urlColumn = tableColumnsCopy.find(col => col.field === 'url')
      urlColumn.formatterParams = this.urlParams
      urlColumn.accessorDownload = (value) => this.urlParams[value]
      urlColumn.editorParams.values = this.mappedUrls = []
      urlColumn.cellContext = (e, cell) => {
        let _filters = this.tableFilters
        _filters.push({ field: cell._cell.column.field, type: '=', value: this.urlParams[cell._cell.value] })
        this.setFilter(_filters)
      }
      urlColumn.cellDblClick = (e, cell) => {
        const row = cell.getRow()
        const publishedUrl = row.getCell('published_url').getValue()
        const value = publishedUrl || this.urlParams[cell._cell.value]
        window.open(value, '_blank').focus()
      }
      urlColumn.editorParams.searchFunc = (term, values) => {
        if (typeof term === 'number') {
          term = this.urlParams[term]
        }
        const matches = values.filter(val => val.label.toLowerCase().includes(term.toLowerCase()))
        return matches
      }

      const vueComponent = this
      this.table = new Tabulator(this.$refs.table, {
        data: vueComponent.tableData,
        height: '100%',
        pageLoaded: () => {
          // issue with tabulator not always rendering all rows - this forces a redraw
          vueComponent.table.redraw()
        },
        persistenceID: 'kwc_table',
        persistenceMode: 'local',
        persistence: {
          columns: ['width', 'visible', 'frozen']
        },
        clipboard: 'copy',
        clipboardCopyRowRange: 'active',
        clipboardCopyConfig: {
          columnHeaders: false, // do not include column headers in clipboard output
          // columnGroups:false, // do not include column groups in column headers for printed table
          // rowGroups:false, // do not include row groups in clipboard output
          columnCalcs: false // do not include column calculation rows in clipboard output
          // dataTree:false, // do not include data tree in printed table
          // formatCells:false, // show raw cell values without formatter
        },
        clipboardCopied() {
          ToasterService.showToast(ToasterService.INFO_TYPE, 'Copied to clipboard')
        },
        autoResize: true,
        layout: 'fitColumns',
        resizableColumns: true,
        movableColumns: true,
        headerSortTristate: true,
        headerSortElement: "<i class='fas fa-caret-up'></i>",
        paginationSize: 100,
        selectable: true,
        headerFilterPlaceholder: '',
        initialSort: savedParams && savedParams.sorters ? savedParams.sorters : [
          {
            column: 'metric_msv_broad_adjusted_1',
            dir: 'desc'
          }
        ],
        initialFilter: savedParams && savedParams.filters ? savedParams.filters : null,
        tooltips(cell) {
          if (cell._cell.column.field === 'url') {
            return vueComponent.urlParams[cell.getValue()]
          }
          if (cell._cell.column.field === 'content_brief_status') {
            return vueComponent.contentBriefParams[cell.getValue()]
          }
          return cell.getValue()
        },
        tooltipsHeader: true,
        pagination: 'remote',
        ajaxSorting: true,
        ajaxFiltering: true,
        ajaxURL: ajaxUrl,
        // ajaxConfig: 'POST', // ajax HTTP request type
        ajaxContentType: 'json', // send parameters to the server as a JSON encoded string
        ajaxParams: { client_id: vueComponent.clientId },
        ajaxConfig: {
          method: "POST", //set request type to Position
          headers: {
            "Content-type": 'application/json; charset=utf-8', //set specific content type
            "resource-page": vueComponent.$router.currentRoute.path,
          },
        },
        columns: tableColumnsCopy,
        dataFiltering() {
          vueComponent.loadAggregates()
        },
        ajaxRequesting() {
          vueComponent.updateFilters()
        },
        ajaxResponse(url, params, response) {
          vueComponent.webPropertyPatterns = response._web_property_patterns
          Object.assign(vueComponent.contentBriefParams, response._content_brief_params)
          const newUrls = response._urls_json
          vueComponent.mappedUrls.splice(0, vueComponent.mappedUrls.length, ...newUrls)
          Object.assign(vueComponent.urlParams, response._url_params)
          vueComponent.isDataLoading = false
          return response
        },
        cellEdited(cell) {
          let params = {
            field: cell._cell.column.field,
            value: cell._cell.value,
            pk: cell._cell.row.data.id
          }
          vueComponent.updateField({ form: params })
          vueComponent.loadAggregates()
        }
      })
    }
  },
}

</script>

<style lang="scss">
.tabulator-edit-select-list {
  padding: 4px;
  background-color: #f4fbfa;
  color: white;
}

.tabulator-header-filter {

  // > input {
  //   outline: none;
  //   border: none;
  //   border-bottom: 1px solid #7D8F9D;
  // }
  >input.no-x[type="search"]::-webkit-search-decoration,
  >input.no-x[type="search"]::-webkit-search-cancel-button,
  >input.no-x[type="search"]::-webkit-search-results-button,
  >input.no-x[type="search"]::-webkit-search-results-decoration {
    display: none;
  }
}

.tabulator {
  border: none;
}

.tabulator-calcs {
  color: #7c8e9b;
}

.tabulator-col-title {
  color: #011627;
}

/* Define the style when the column is not sorted */
.tabulator-col[aria-sort="none"] .tabulator-col-sorter i {
  color: #999;
  font-size: 20px;
}

/* Define the style when the column is sorted in ascending order */
.tabulator-col[aria-sort="asc"] .tabulator-col-sorter i {
  color: $rfx-bright-blue;
  font-size: 20px;
}

/* Define the style when the column is sorted in descending order */
.tabulator-col[aria-sort="desc"] .tabulator-col-sorter i {
  color: $rfx-bright-blue;
  transform: scaleY(-1);
  /* flip the icon vertically so the arrow points down */
  font-size: 20px;
}
</style>

<style scoped lang="scss">
/* clears the 'x' from search inputs in Chrome */
// input[type="search"]::-webkit-search-decoration,
// input[type="search"]::-webkit-search-cancel-button,
// input[type="search"]::-webkit-search-results-button,
// input[type="search"]::-webkit-search-results-decoration { display: none; }

#export-tab-dropdown {
  height: 20px !important;
  padding: 5px;
  cursor: pointer;
}

#export-tab-dropdown-container {
  padding: 0;
}

#add-tab-dropdown {
  height: 20px !important;
  padding: 5px;
  cursor: pointer;
}

#add-tab-dropdown-container {
  padding: 0;
}

.container {
  margin: auto;
  margin-top: 10px;
  width: 100%;
}

ul {
  list-style: none;
}

.gauge-td {
  text-align: right;
}

.gauge-td-mid {
  white-space: nowrap;
}

#main-table {
  margin-top: 30px;
}

.progress-ring {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
}

.metrics {
  margin-top: 10px;
  margin-right: 25px;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &__metric {
    display: block;
    font-size: 11px;
    font-weight: bold;
    color: #7c8e9b;
    height: 13px;

    &__filtered {
      font-size: 20px;
      color: #011627;
    }
  }
}

.kc {

  &__title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title-left {
    width: 80%;
    display: flex;
  }

  &__title-right {
    display: flex;
  }

  &__update-loader {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: white;
    top: 0;
    opacity: 0.5;
    z-index: 10000;
  }

  &__update-loader-ring {
    margin-top: 200px;
  }

  &__filter_pills {
    margin: 5px 20px;
    width: 75%;
  }

  &__tabs {
    display: grid;
    width: 50%;
    margin: 5px 0;
    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
    height: 40px;
    flex: 15%;
    height: 34px;

    &.function-tabs {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    &.page-tabs {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &__buttons_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__tab {
    font-weight: 500;
    outline: none;
    font-size: 10px;
    border: 1px solid $rfx-light-steel;
    color: $rfx-dark-march;
    margin: 0;
    cursor: pointer;
    transition: box-shadow .3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    text-decoration: none;
    padding: 5px;

    &:hover {
      /* box-shadow: 0 0 11px 5px rgba(33,33,33,.2); */
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;

    }

    &_center {
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
    }

    &_disabled {
      pointer-events: none;
      cursor: default;
    }

    &_active {
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;
    }

    &__enabled {
      color: $rfx-bright-blue
    }
  }

  &__icon {
    font-size: 20px;
  }

  &__gauge-container {
    width: 400px;
    margin: 30px 0;
    font-size: 12px;
    font-weight: 900;
  }

  &__gauge-span {
    float: right;
  }

  &__filters {
    width: 750px;
    position: absolute;
    z-index: 99;
    background-color: white;
    border-radius: 13px;
    text-align: left;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 20px;

    &_header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    }

    &_title {
      font-size: 16px;
      font-weight: 500;
    }

    &_close {
      cursor: pointer;
    }
  }
}
</style>
